import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import React from "react";
import { FaqList } from "./faq/list/FaqList";
import { FaqDetail } from "./faq/detail/FaqDetail";
import { FaqDetailInput } from "./faq/detail/FaqDetailInput";
import { QnaList } from "./qna/list/QnaList";
import { QnaDetail } from "./qna/detail/QnaDetail";
import { RmaDetail } from "./rma/detail/RmaDetail";
import { RmaList } from "./rma/RmaList";
import BoardList from "./board/list/BoardList";
import BoardDetail from "./board/detail/BoardDetail";
import BoardDetailInput from "./board/detail/BoardDetailInput";
import { RmaDetailInput } from "./rma/detail/RmaDetailInput";
import { QnaDetailInput } from "./qna/detail/QnaDetailInput";

export default function Support() {
  const { key } = useLocation();

  return (
    <Routes>
      <Route key={key} path={"faq/list"} element={<FaqList />} />
      <Route key={key} path={"faq/detail/:id"} element={<FaqDetail />} />
      <Route key={key} path={"faq/update/:id"} element={<FaqDetailInput />} />
      <Route key={key} path={"faq/create"} element={<FaqDetailInput />} />
      <Route key={key} path={"qna/list"} element={<QnaList />} />
      <Route key={key} path={"qna/detail/:id"} element={<QnaDetail />} />
      <Route key={key} path={"qna/update/:id"} element={<QnaDetailInput />} />
      <Route key={key} path={"qna/create"} element={<QnaDetailInput />} />
      <Route key={key} path={"rma/list"} element={<RmaList />} />
      <Route key={key} path={"rma/detail/:id"} element={<RmaDetail />} />
      <Route key={key} path={"rma/update/:id"} element={<RmaDetailInput />} />
      <Route key={key} path={"rma/create"} element={<RmaDetailInput />} />
      <Route key={key} path={"board/list"} element={<BoardList />} />
      <Route key={key} path={"board/detail/:id"} element={<BoardDetail />} />
      <Route
        key={key}
        path={"board/update/:id"}
        element={<BoardDetailInput />}
      />
      <Route key={key} path={"board/create"} element={<BoardDetailInput />} />
      <Route
        key={key}
        path={"*"}
        element={<Navigate to={"/not_found"} />}
      />
    </Routes>
  );
}
